import { useStoreon } from "storeon/react";
import { IDependentStore, IDependentEvents } from "../store/dependentStore";

export const useDependentStore = () => {
  const { dependentStore, dispatch: dependentDispatch } = useStoreon<IDependentStore, IDependentEvents>("dependentStore");

  return {dependentStore, dependentDispatch};
}